import { render, staticRenderFns } from "./Examine.vue?vue&type=template&id=b5bd677e&scoped=true&"
import script from "./Examine.vue?vue&type=script&lang=js&"
export * from "./Examine.vue?vue&type=script&lang=js&"
import style0 from "./Examine.vue?vue&type=style&index=0&id=b5bd677e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bd677e",
  null
  
)

export default component.exports